import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChecklist = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "checklist" }),
		/* @__PURE__ */ _jsx("rect", {
			className: "a",
			x: .75,
			y: .749,
			width: 22.5,
			height: 22.5,
			rx: 1.5,
			ry: 1.5
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "a",
			points: "12 4.499 7.5 10.499 4.5 7.499"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 14.25,
			y1: 8.249,
			x2: 18.75,
			y2: 8.249
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "a",
			points: "12 13.499 7.5 19.499 4.5 16.499"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 14.25,
			y1: 17.249,
			x2: 18.75,
			y2: 17.249
		})
	]
});
export default SvgChecklist;
